import React from 'react';

import {buildCatalogMap, getParents} from '../../lib/catalog';
import {default as CatalogInput2} from '../CatalogInput';
import {getQuestionMetadata} from '../../screens/FormBuilderScreen/shared';

//an answer is always a leaf item, from one of the catalog types the question is restricted to when it has any

function MultiCatalogInput({id, question, label, catalog, values, onChange, invalid, autoOpen}) {
  const catalogById = buildCatalogMap(catalog);
  const itemIds = values.map(value => value.split(',')).map(values => values[values.length - 1]);

  return (
    <CatalogInput2
      id={id}
      multiple
      label={label}
      catalog={catalog}
      selectableTypeIds={getQuestionMetadata(question, 'selectedTypes')}
      leafOnly
      autoOpen={autoOpen}
      value={itemIds}
      onChange={itemIds => {
        const items = itemIds.map(itemId => {
          const item = catalogById[itemId];
          const parents = getParents(item, catalogById).reverse();

          return [...parents, item].map(item => item.id).join(',');
        });
        
        onChange(items, items.length > 0);
      }}
      invalid={invalid}
    />
  );
}

export default MultiCatalogInput;
